import { render, staticRenderFns } from "./MyDormGaleriLogo.vue?vue&type=template&id=315ed448&"
import script from "./MyDormGaleriLogo.vue?vue&type=script&lang=js&"
export * from "./MyDormGaleriLogo.vue?vue&type=script&lang=js&"
import style0 from "./MyDormGaleriLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MyDormGaleriLogo.vue"
export default component.exports